<template>
  <div class="ordersalesMain">
    <div class="title-box">设备总收益</div>
    <div class="data-info">
      <div class="data-item main">
        <div class="title">
          总收益
        </div>
        <div class="number">{{ handleControlNumber(sumSales, 2) }}</div>
      </div>
      <div class="data-item">
        <div class="title">
          电费
        </div>
        <div class="number">
          {{ handleControlNumber(data.pileIncomeVO?.chargeFee || 0, 2) }}
        </div>
      </div>
      <div class="data-item">
        <div class="title">
          服务费
        </div>
        <div class="number">{{ handleControlNumber(data.pileIncomeVO?.serviceFee || 0, 2) }}</div>
      </div>
    </div>

    <div class="chart-box">
      <div class="text">按时间查询</div>
      <el-tooltip popper-class="order-sales_chart-tips" effect="dark" content="Bottom Left 提示文字"
                  placement="bottom-start">
        <div slot="content" class="tips-box">
          <div>当日查询：按小时显示数据；</div>
          <div>天数查询：按天显示数据；</div>
        </div>
        <img class="icon" src="@/assets/image/icon/tips.png"/>
      </el-tooltip>
    </div>


    <div class="selectHead">
      <div class="item" @click="stimeshow = true">
        <img class="icon" src="@/assets/image/icon/calender.png"/>
        <div class="label">
          {{ choose.stime || '开始时间：' }}
        </div>
        <i class="el-icon el-icon-arrow-down"></i>
      </div>
      <div class="item" @click="etimeshow = true">
        <img class="icon" src="@/assets/image/icon/calender.png"/>
        <div class="label">
          {{ choose.etime || '结束时间：' }}
        </div>
        <i class="el-icon el-icon-arrow-down"></i>
      </div>
    </div>
    <nut-datepicker
        :is-visible="stimeshow"
        type="date"
        title="请选择开始日期"
        :is-show-chinese="false"
        @close="stimeshow = false"
        @choose="startTimeChange"
    >
    </nut-datepicker>
    <nut-datepicker
        :is-visible="etimeshow"
        type="date"
        title="请选择结束日期"
        :is-show-chinese="false"
        @close="etimeshow = false"
        @choose="endTimeChange"
    >
    </nut-datepicker>
    <!--    <div class="options">-->
    <!--      <div @click="handleClickSwatch(item,index)" v-for="(item,index) in optionList" :key="`option-item_${index}`"-->
    <!--           class="option-item"-->
    <!--           :class="{'options-item_actived': optionIndex == index}">{{ item.name }}-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="chart">
      <div class="chart" ref="chart"></div>
    </div>
  </div>
</template>
<script>
import {formatDate} from "@/utils/formart";
import {getSalesDetailByParams} from "@/api/newApi";
import {digitUtil} from "@/utils/utils";

export default {
  data() {
    return {
      sumSales: 0.0,
      optionList: [
        {name: "订单数"},
        {name: "销售额"},
      ],
      optionIndex: 0,
      a: formatDate(new Date(), "yyyy-MM-dd"),
      stimeshow: false,
      etimeshow: false,
      starttime: formatDate(
          new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 7),
          "yyyy-MM-dd"
      ),
      endtime: formatDate(new Date(), "yyyy-MM-dd"),
      start: {
        minHour: 10,
        maxHour: 20,
        maxDate: new Date(),
        currentDate: new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 7),
      },
      end: {
        minHour: 10,
        maxHour: 20,
        minDdate: this.starttime,
        maxDate: new Date(),
        currentDate: new Date(),
      },
      choose: {
        parkid: "",
        stime: formatDate(
            new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 30),
            "yyyy-MM-dd"
        ),
        etime: formatDate(new Date(), "yyyy-MM-dd"),
      },
      data: {},
      chartOptions: {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          formatter: (params) => {
            return `<div>
                        <div style="margin-bottom: 5px;">
                            <span style="color: #888888;font-size: 12px;">${params[0].seriesName}</span>: <span style="color: #333333;font-size: 12px;">${params[0].data}</span>
                        </div>
                        <div>
                            <span style="color: #888888;font-size: 12px;padding-top: 15px">${params[1].seriesName}</span>: <span style="color: #333333;font-size: 12px;">${params[1].data}</span>
                        </div>
                    </div>`
          },
          padding: [10, 10, 10, 10],
          extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);',
          borderColor: "#888888",
          textStyle: {
            color: "#888888",
            fontSize: 10,
          },
          axisPointer: {
            type: "line"
          }
        },
        legend: {
          show: true,
          bottom: "5%",
          left: "30%",
          right: "0%",
          textStyle: {
            fontSize: 12,
            color: '#1D2129',
          },

          itemStyle: {},
        },
        grid: {
          left: '3%',
          right: '4%',
          top: '10%',
          containLabel: true
        },
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100, // 调整为 100% 显示所有数据
          maxSpan: 100 // 调整最大跨度
        }],
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#86909C",
            fontSize: 12
          },
          axisLine: {
            lineStyle: {
              color: "#CCCFD6"
            },
          },
          data: ["123123"],
        },
        yAxis: {
          type: 'value',
          minInterval: 0.1,
          textStyle: {
            color: "#FFF",
            fontSize: 30
          },
          axisLabel: {
            color: "#86909C",
            fontSize: 12
          },
          splitLine: {
            lineStyle: {
              color: "#E5E6EB",
              type: "dashed"
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        series: [
          {
            name: '销售额',
            type: 'line',
            color: "#14C9C9",
            symbol: 'circle', // 强制显示点
            symbolSize: 5, // 调整点的大小
            smooth: true,
            data: [2],
          },
          {
            name: '订单数',
            type: 'line',
            color: "#165DFF",
            symbol: 'circle', // 强制显示点
            symbolSize: 5, // 调整点的大小
            smooth: true,
            data: [1],
          },
        ]
      },
    };
  },
  components: {},
  watch: {},
  mounted() {
    if (this.$route.query.id) {
      this.choose.parkid = this.$route.query.id;
      this.getOrderData();
    }
    this.data = JSON.parse(localStorage.getItem("EQUIP_DETAIL"))
    this.initChart()
  }
  ,
  methods: {
    handleControlNumber: digitUtil,
    handleClickSwatch(item, index) {
      this.optionIndex = index
    },
    initChart() {
      let myChart = this.$echarts.init(this.$refs.chart);
      let option = {
        ...this.chartOptions,
      };
      myChart.setOption(option);
    }
    ,
    endTimeChange(e) {
      if (e[3] < this.a) {
        this.$toast.text("结束时间不能小于开始时间");
        return;
      }
      this.endtime = e[3];
      this.choose.etime = e[3];
      this.etimeshow = false;
      this.getOrderData();
    }
    ,
    startTimeChange(e) {
      this.a = e[3];
      this.starttime = e[3];
      this.choose.stime = e[3];
      this.stimeshow = false;
      this.getOrderData();
    }
    ,
    getOrderData() {
      getSalesDetailByParams({
        parkid: this.choose.parkid,
        startTime: this.choose.stime,
        endTime: this.choose.etime,
      }).then((res) => {
        console.log(res);
        if ((res.message.message = "success")) {
          // this.chartOptions.xAxis.data = [...[]];
          // this.chartOptions.series[0].data = [...[]];
          // this.chartOptions.series[1].data = [...[]];
          let sumSales = 0;
          let validCount = 0;
          let createTimeList = [];
          let validCountList = [];
          let sumSalesList = [];

          res.data.forEach((element) => {
            createTimeList.push(element.createTime);
            //'有效订单数', '收益'
            validCountList.push(element.validCount);
            sumSalesList.push(element.sumSales);
            sumSales = sumSales + element.sumSales * 1;
            validCount = validCount + element.validCount
          });
          this.chartOptions.xAxis.data = createTimeList
          this.chartOptions.series[0].data = sumSalesList
          this.chartOptions.series[1].data = validCountList
          console.log(this.chartOptions)
          this.initChart();
        }
      });
    }
    ,
  }
  ,
};
</script>
<style lang="scss">
.order-sales_chart-tips {

  background-color: white !important;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5) !important;

  .popper__arrow {
    border-bottom-color: white !important;

    &:after {
      border-bottom-color: white !important;
    }
  }

  .tips-box {
    padding: 0.1rem;
    font-size: 0.2702rem;
    color: #888888;

    div:last-child {
      margin-top: 0.2rem;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.ordersalesMain {
  //padding: 0.2667rem 0.4rem;
  padding: $divPadding;
  background-color: white;
  min-height: 100%;


  .title-box {
    color: #666666 !important;
    font-size: 0.3783rem;
    padding: 0 !important;
    padding-bottom: 0.3rem !important;
  }

  .data-info {
    display: flex;
    justify-content: space-between;

    .data-item {
      width: 2.5864rem;
      height: 1.6216rem;
      border-radius: $borderRadius;
      background: linear-gradient(148deg, #8CA4DA 0%, #9DB6EF 100%);
      box-shadow: 0 0.1081rem 0.2702rem 0 rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: space-around;
      flex-direction: column;
      padding: 0.25rem;
      color: white;
      margin-bottom: 0.1rem;

      .title {
        font-size: 0.2702rem;
      }

      .number {
        font-size: 0.4324rem;
      }
    }

    .main {
      width: 3.2702rem;
      background: linear-gradient(135deg, #346EF1 0%, #5095FD 98%);
    }
  }

  .chart-box {
    color: #444444;
    font-size: 0.3243rem;
    padding: 0.3rem 0;
    display: flex;
    position: relative;

    .text,
    .icon {
      align-self: center;
    }

    .icon {
      width: 0.3702rem;
      height: 0.3702rem;
      margin-left: 0.1rem;
    }


  }


  .selectHead {
    display: flex;
    background-color: #F5F5F5;
    border-radius: 0.1081rem;

    .item {
      display: flex;
      padding: 0.2rem;
      width: 50%;


      &:first-child {
        position: relative;
        padding-right: 0.3rem;

        &:before {
          content: '至';
          position: absolute;
          right: -0.15rem;
          font-size: 0.3243rem;
        }
      }

      &:last-child {
        padding-left: 0.3rem;
      }

      .icon {
        width: 0.3702rem;
        height: 0.3702rem;
        margin-right: 0.2rem;
      }

      .label {
        color: #888888;
        flex: 1;
      }

      .icon,
      .label,
      .el-icon {
        align-self: center;
        font-size: 0.3243rem;

      }
    }
  }

  .options {
    display: flex;
    padding-top: $divPadding;

    .option-item {
      background-color: #F5F5F5;
      color: #4E5969;
      border-radius: 1rem;
      padding: 0.1rem 0.3rem;
      margin-right: 0.2rem;
      font-size: 0.3243rem;
    }

    .options-item_actived {
      background-color: #2B69F7;
      color: white;
    }
  }

  .chart {
    width: 100%;
    margin-top: 0.3rem;

    .chart {
      height: 7rem;
      width: 100%;
    }
  }
}
</style>
